import React, { Fragment, useState } from "react";
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";
import ChatBox from "../ChatBox";
import { useAuth } from "../../../context/AuthContext";
const JobieNav = ({ title }) => {
  const { currentUser, logout } = useAuth();
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);
  return (
    <Fragment>
      <NavHader />
      <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} />
      <Header
        onNote={() => onClick("chatbox")}
        onNotification={() => onClick("notification")}
        onCpapPurchaseNotification={() =>
          onClick("cpap-purchase-notification")
        }
        onAnnualMaskPurchaseNotification={() =>
          onClick("annual-mask-purchase-notification")
        }
        onPatientPortalTicketNotification={() =>
          onClick("patient-portal-ticket-notification")
        }
        onProfile={() => onClick("profile")}
        toggle={toggle}
        title={title}
        onBox={() => onClick("box")}
        onLogout={logout}
        user={currentUser}
      />
      <SideBar />
    </Fragment>
  );
};

export default JobieNav;
